import React, { Fragment } from "react";
import { Form, Label, Row, Col, Input } from "reactstrap";
import { useQuery } from "@apollo/client";
import { GET_ALL_COUNTRIES } from "../../../queries";
import { useSupporterSignUpContext } from "../context/SupporterStatusContext";

const Step2 = ({ update }) => {
  const { loading, error, data: formOptions } = useQuery(GET_ALL_COUNTRIES);
  const { state, dispatch } = useSupporterSignUpContext();

  return (
    <Fragment>
      <div className="form-wizard-content">
        <Form>
          <Row
            style={{
              marginBottom: "20px",
            }}
          >
            <Col xs={12} md={3}>
              <Label for="sdgs" className="mr-sm-2">
                関心のある SDGsゴール
              </Label>
            </Col>
            <Col xs={12} md={9}>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                }}
              >
                {!loading && (
                  <>
                    {formOptions.allSdgs.edges.map((sdg) => (
                      <img
                        alt={sdg.node.id}
                        className="px-1 mb-2 pointer"
                        style={{
                          width: "3.5rem",
                          opacity: state?.focusedSdges?.includes(
                            update ? sdg.node.id : sdg.node.intId
                          )
                            ? 1
                            : 0.5,
                        }}
                        src={sdg.node.logoUrl}
                        onClick={(e) => {
                          dispatch({
                            type: "HANDLE_CHECKBOX_CHANGE",
                            payload: {
                              name: "focusedSdges",
                              value: update ? sdg.node.id : sdg.node.intId,
                              checked: !state?.focusedSdges?.includes(
                                update ? sdg.node.id : sdg.node.intId
                              ),
                            },
                          });
                        }}
                        key={sdg.node.id}
                      />
                    ))}
                  </>
                )}
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={3}>
              大切にしたいステークホルダー
            </Col>
            <Col xs={12} md={9}>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  marginLeft: "20px",
                }}
              >
                {formOptions?.allTarget?.edges?.map((target) => {
                  return (
                    <Label
                      check
                      style={{
                        marginRight: "36px",
                        marginBottom: "8px",
                      }}
                    >
                      <Input
                        type="checkbox"
                        name="focusedStakeholders"
                        // value={target.node.id}
                        defaultChecked={state?.focusedStakeholders?.includes(
                          update ? target.node.id : target.node.intId
                        )}
                        onChange={(e) => {
                          dispatch({
                            type: "HANDLE_CHECKBOX_CHANGE",
                            payload: {
                              name: "focusedStakeholders",
                              value: update
                                ? target.node.id
                                : target.node.intId,
                              checked: e.target.checked,
                            },
                          });
                        }}
                      />{" "}
                      {target.node.name}
                    </Label>
                  );
                })}
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </Fragment>
  );
};

export default Step2;
